import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Card, Divider } from 'antd';
import globalStore from 'ts/store/Global';
import gitstatStore, { ITogglData } from '../store/GitStatistics';
import contributorsStore from 'ts/pages/ContributorsList/store/Contributors';
import CommitStatHeader from './CommitStatHeader';
import CommitStatTotals from './CommitStatTotals';
import CommitsListView from './CommitsListView/CommitsListView';
import {
  cardBody,
  card,
  divider,
  listContainer,
} from '../styles/styles';

const CommitStat = () => {
  useEffect(() => {
    if (globalStore.contributorId !== null) {
      gitstatStore.setCommitsList();
      gitstatStore.setTogglData();
    }
  }, [globalStore.dateRange, globalStore.contributorId]);

  useEffect(() => {
    if (contributorsStore.contributorsList.length === 0) {
      contributorsStore.setContributorsList();
    }
  }, []);

  return (
    <Card
      style={card}
      styles={{ body: cardBody }}
      title={<CommitStatHeader />}
    >
      <CommitStatTotals
        commitsList={gitstatStore.commitsList}
        togglData={gitstatStore.togglData as ITogglData}
      />
      <Divider style={divider} />
      <div style={listContainer}>
        <CommitsListView commitsList={gitstatStore.commitsList} />
      </div>
    </Card>
  );
};

export default observer(CommitStat);
